export enum CodeStatus {
  Pending = 'PENDING',
  Expired = 'EXPIRED',
  Activated = 'ACTIVATED',
  Canceled = 'CANCELED'
}
